<template>
  <div>
    <v-container>
      <advice color="primary" marginLeft="0px">
        <span
          class="caption grey--text text--darken-1"
          v-html="$t('profile.changePassword.advice')"
        >
        </span>
      </advice>

      <v-form ref="form" class="mt-4" v-model="valid">
        <v-text-field
          :label="$t('global.placeholder.old.password')"
          v-model="model.oldPassword"
          :rules="passwordRules"
          type="password"
          required
        ></v-text-field>

        <v-text-field
          :label="$t('global.placeholder.new.password')"
          v-model="model.newPassword"
          :rules="passwordRules"
          type="password"
          required
        ></v-text-field>

        <v-text-field
          :label="$t('global.placeholder.repeat.new.password')"
          v-model="model.repeatNedPassword"
          :rules="passwordRules"
          type="password"
          required
        ></v-text-field>
      </v-form>
    </v-container>

    <v-card-actions class="px-4 pb-3">
      <v-spacer></v-spacer>
      <v-btn
        class="initialize"
        color="primary"
        round
        outline
        :disabled="!valid"
        :loading="isLoading"
        @click="saveForm"
        >{{ $t('global.button.save') }}</v-btn
      >
    </v-card-actions>
  </div>
</template>

<script>
import Advice from '@/components/commons/Advice';
import passwordService from '@/services/passwordService';
import manageErrorService from '@/services/manageErrorService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ChangePassword',
  components: {
    [Advice.name]: Advice
  },
  computed: {
    passwordRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v => v.length >= 4 || this.$i18n.t('global.validation.minimum.4'),
        v => v.length <= 50 || this.$i18n.t('global.validation.maximum.50'),
        this.model.newPassword === this.model.repeatNedPassword ||
          this.$i18n.t('global.validation.password.equals')
      ];
    }
  },
  data() {
    return {
      valid: false,
      isLoading: false,
      model: {
        oldPassword: '',
        newPassword: '',
        repeatNedPassword: ''
      }
    };
  },
  methods: {
    async saveForm() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      this.isLoading = true;

      let form = {
        oldPassword: this.model.oldPassword,
        newPassword: this.model.newPassword
      };

      this.isLoading = true;

      let results = await passwordService.changePassword(form);

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        return;
      }

      this.isLoading = false;
      this.editMode = false;

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('profile.password.update.success'),
        type: 'info',
        doNotTranslate: true
      });
    }
  }
};
</script>
